export enum OrderTypeEnum {
  NORMAL = 1,
  UNPAID = 2,
  EVENT = 3,
  STORAGE = 4,
  PAID_SAMPLE = 5,
  HYBRID = 6,
  POD = 7,
}
export interface ProjectManagementBasicDetails {
  id: number;
  order_id: number;
  label?: string;
  order_type_id?: number;
  order_type?: OrderTypeEnum;
  customer_id: number;
  customer_name?: string;
  start_date?: Date;
  due_date?: Date;
  delivery_date: Date;
  dispatch_date?: Date;
  pm_admin_id?: number;
  pm_admin_name?: string;
  sales_admin_id?: number;
  sales_admin_name?: string;
  admin_id: number;
  admin_name?: string;
  active?: boolean;
  archived?: boolean;
  archived_adminid?: number;
  archived_adminname?: string;
  archived_date?: Date;
  created_date?: Date;
  modified_date?: Date;
  progress?: number;
  days_to_dispatch?: number;
  shipment_dispatch_date?: Date;
  warehouse_id?: string;
  warehouse_identifier?: string;
}

export interface ProductSourcingInfo {
  customisation_required: number;
  order_id: number;
  ordered_quantity: number;
  pi_qc_started: number;
  pi_total_received_quantity: number;
  pi_total_rejected_quantity: number;
  po_total_received_sent: number;
  product_id: number;
  ri_qc_started: number;
  ri_total_received_quantity: number;
  ri_total_rejected_quantity: number;
  pr_quantity: number;
  po_quantity: number;
}
